export default {
  required: '請輸入',
  requiredSelect: '請選擇',
  basicInfo: '基礎信息',
  serviceProvider: '服務商',
  serviceProviderPlaceholder: '請選擇服務商',
  apiKey: 'API Key',
  apiKeyPlaceholder: '請輸入活動ID',
  apiSecret: 'API Secret',
  apiSecretPlaceholder: '請輸入活動ID',
  smsSignature: '短信簽名',
  smsSignaturePlaceholder: '請輸入活動ID',
  channelConfig: '海外通道配置',
  addChannel: '添加通道',
  countryRegion: '國家/地區',
  operator: '服務商',
  operatorPlaceholder: '請選擇',
  templateCode: '模板code',
  templateCodePlaceholder: '請輸入模板code',
  status: '狀態',
  actions: '操作',
  edit: '編輯',
  delete: '刪除',
  sendTest: '短信發送測試',
  testPhone: '請輸入手機號',
  sendTestSms: '發送測試短信',
  sendTestSuccess: '測試短信發送成功',
  sendTestFail: '測試短信發送失敗',
  save: '保存配置',
  saveSuccess: '保存成功',
  deleteConfirm: '確認刪除該通道？',
  deleteSuccess: '刪除成功',
  selectChannel: '請選擇通道',
  // Tab
  tabConfig: '短信配置',
  tabSendLog: '發送日誌',
  // 日誌篩選
  logMobile: '手機號',
  logMobilePlaceholder: '請輸入手機號',
  logTemplateCode: '模板Code',
  logTemplateCodePlaceholder: '請輸入模板Code',
  logStatus: '發送狀態',
  logStatusAll: '全部狀態',
  logStatusSuccess: '成功',
  logStatusFailed: '失敗',
  logProvider: '服務商',
  logProviderAll: '全部服務商',
  logSendTime: '發送時間',
  logStartDate: '開始日期',
  logEndDate: '結束日期',
  logSearch: '查詢',
  logReset: '重置',
  logCollapse: '收起',
  logExpand: '展開',
  logAllCountries: '全部國家/地區',
  // 日誌表格
  logColumnCountry: '國家/地區',
  logColumnMobile: '手機號',
  logColumnTemplateCode: '模板Code',
  logColumnProvider: '服務商',
  logColumnStatus: '狀態',
  logColumnSendTime: '發送時間',
  logColumnMessageId: '服務商消息ID',
  logColumnActions: '操作',
  logDetail: '詳情',
  // 統計卡片
  statTotalCount: '發送總數',
  statSuccessCount: '成功數',
  statFailedCount: '失敗數',
  statSuccessRate: '成功率',
  // 詳情抽屜
  detailTitle: '短信發送詳情',
  detailMobile: '手機號',
  detailCountry: '國家/地區',
  detailProvider: '服務商',
  detailTemplateCode: '模板Code',
  detailTemplateName: '模板名稱',
  detailContent: '短信內容',
  detailStatus: '發送狀態',
  detailMessageId: '服務商消息ID',
  detailRequestId: '平台請求ID',
  detailSendTime: '發送時間',
  detailCallbackTime: '回調時間',
  detailResponse: '返回結果',
  detailErrorCode: '錯誤碼',
  detailErrorMsg: '錯誤信息',
  detailClose: '關閉',
  detailNone: '-',
};
